import { useLocation, useParams } from "react-router-dom";

export const useLocationForReportType = () => {
  const location = useLocation();
  const { pathname } = location;
  const { reportId } = useParams();

  if (pathname.includes("followup-messages")) {
    return "followup-messages";
  }
  if (location.pathname.includes("control-center")) {
    return "control-center";
  }
  if (pathname.includes("followup")) {
    return "followup";
  }
  if (pathname.includes("inprogress")) {
    if (reportId) {
      return "inprogressInsideReport";
    }
    return "inprogress";
  }
  return null;
};
